export enum PrimasStartWithTextFilterOperator {
  StartsWith = "Starts With",
}